/* eslint-disable */
const internals = {
  $this: $('.mod-new-calculator'),
  initEles () {
    this.$itWhite = this.$this.find('#ITWhiteSpace')
    this.$actualIT = this.$this.find('#ActualCriticalITLoad')
    this.$currentPower = this.$this.find('#CurrentPowerDensity')
    this.$selectAnnualizedPUE = this.$this.find('#select-estimated-annualized-PUE')
    this.$currentElectricalRate = this.$this.find('#CurrentElectricalRate')
    this.$selectLocation = this.$this.find('#select-location')
    this.$selectCityUS = this.$this.find('#select-city-us')
    this.$selectCityCanada = this.$this.find('#select-city-canada')
    this.$selectUPS = this.$this.find('#select-UPS')
    this.$selectHeatTejectionType = this.$this.find('#select-heat-tejection-type')
    this.$selectGeneratorRedundancy = this.$this.find('#select-generator-redundancy')
    this.$selectPlanRedundancy = this.$this.find('#select-plan-redundancy')
    this.$annualElectricUtility = this.$this.find('#annualElectricUtility')
    this.$annualMaintenanceCost = this.$this.find('#annualMaintenanceCost')
    this.$annualTaxesInsurance = this.$this.find('#annualTaxesInsurance')
    this.$estimatedAnnualOperating = this.$this.find('#estimatedAnnualOperating')
    this.$equivalentSTACK = this.$this.find('#equivalentSTACK')
    this.$annualCostSavings = this.$this.find('#annualCostSavings')
  },
  mapRateCity (cityValue) {
    return {
      'Atlanta, GA': 0.0531,
      'Chicago, IL': 0.0687,
      'Dallas, TX': 0.067,
      'New Albany, OH': 0.0657,
      'Northern VA': 0.0525,
      'Phoenix, AZ': 0.0735,
      'Portland, OR': 0.0709,
      'Silicon Valley, CA': 0.125,
      'Calgary, AB': 0.07,
      'Toronto, ON': 0.135,
    }[cityValue] || 0
  },
  mapAnnualizedPUE (val) {
    return {
      '< 1.35': 1.35,
      '1.35 - 1.6': 1.6,
      '1.6 - 2.0': 2,
      '> 2.0': 2.5,
    }[val] || 0
  },
  getBoundaryValue (value, min, max) {
    if (value >= max) {
      return max
    }
    return min
  },
  mapNearestKw (kw, kwRanges = [[]]) {
    for (const index in kwRanges) {
      const item = kwRanges[index]
      const min = item[0]
      const max = item[1]
      if (kw <= max) {
        return this.getBoundaryValue(kw, min, max)
      }
    }
    const lastRange = kwRanges[kwRanges.length - 1]
    return this.getBoundaryValue(kw, lastRange[0], lastRange[1])
  },
  getMaintanceCost (kw) {
    const mappedKw = this.mapNearestKw(+kw, [[0, 2000], [2000, 4000], [4000, 6000], [6000, 12000], [12000, 18000], [18000, 24000]])
    return {
      0: 140,
      2000: 120,
      4000: 67,
      6000: 46,
      12000: 28,
      18000: 20,
      24000: 18,
    }[mappedKw] || 0
  },
  getPmAndRepair (kw) {
    const mappedKw = this.mapNearestKw(+kw, [[0, 2000], [2000, 4000], [4000, 6000], [6000, 12000]])
    return {
      0: 7.5,
      2000: 6.9,
      4000: 6,
      6000: 5.75,
      12000: 5.5,
    }[mappedKw] || 0
  },
  mapRedundancy (val) {
    return {
      'None': -1,
      'N': 1.00,
      'N + 1': 1.15,
      '2N': 2.50,
    }[val] || 0
  },
  arrAvg: arr => arr.reduce((a, b) => a + b, 0) / arr.length,
  setDefaultValue () {
    const defaultData = {
      'actualIT': '',
      'itWhite': '',
      'currentElectricalRate': '',
      'selectLocation': 'USA',
      'selectCityUS': 'Atlanta, GA',
      'selectCityCanada': 'Calgary, AB',
      'selectUPS': 'None',
      'selectGeneratorRedundancy': 'None',
      'selectHeatTejectionType': 'Water-Cooled',
      'selectPlanRedundancy': 'None',
      'selectAnnualizedPUE': '< 1.35',
    }
    Object.keys(defaultData).forEach(key => {
      this[`$${key}`].val(defaultData[key])
    });
  },
  calc () {
    const c5 = +this.$actualIT.val()
    const c6 = +this.$itWhite.val()
    const c7 = c6 === 0 ? '' : (1000 * c5 / (+this.$itWhite.val()))
    this.$currentPower.val(Math.round(c7))
    const c8 = +this.$currentElectricalRate.val()
    const c16 = this.$selectUPS.val()
    const c19 = this.$selectGeneratorRedundancy.val()
    const c23 = this.$selectHeatTejectionType.val()
    const c24 = this.$selectPlanRedundancy.val()
    const c28 = this.mapRedundancy(c16)
    const c29 = this.mapRedundancy(c19)
    const c30 = this.mapRedundancy(c24)

    const c31 = (this.arrAvg([c28, c29, c30]) - 1) * this.getPmAndRepair(c5)
    const c32 = this.mapAnnualizedPUE(this.$selectAnnualizedPUE.val())

    // get city
    let cityval = this.$selectCityUS.val()
    if (this.$selectCityUS.parents('.form-select-c8').hasClass('hidden')) {
      cityval = this.$selectCityCanada.val()
    }
    const c33 = c8 === 0 ? this.mapRateCity(cityval) : c8
    const c34 = this.getMaintanceCost(c5) + c31
    const c36 = c23 === 'Water-Cooled' ? (c32 * 31 / 12) : 0
    const c41 = c5 * 8760 * c33 * c32
    const c42 = (c5 * (c34 + c36)) * 12
    const c43 = 9 * c5 * 12
    const c45 = c41 + c42 + c43

    const d32 = 1.3
    const d33 = this.mapRateCity(cityval)
    const d34 = this.getMaintanceCost(24000)
    const c46 = (d34 * c5 * 12) + (c5 * 8760 * d33 * d32) + c43
    const c47 = c45 - c46

    this.$annualElectricUtility.text(c41.toLocaleString())
    this.$annualMaintenanceCost.text(c42.toLocaleString())
    this.$annualTaxesInsurance.text(c43.toLocaleString())
    this.$estimatedAnnualOperating.text(c45.toLocaleString())
    this.$equivalentSTACK.text(c46.toLocaleString())
    this.$annualCostSavings.text(c47.toLocaleString())
  },
  init () {
    this.initEles()
    this.setDefaultValue()
    this.calc()
    this.$this.on('change', 'select', () => {
      this.calc()
    })
    this.$this.on('input', 'input[type="text"],input[type="number"]', () => {
      this.calc()
    })
    //detect type number
    this.$this.on('keypress', '[type="number"]', (e) => {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        e.preventDefault()
      }
    })
    // detect type decimal
    this.$this.on('keypress', '.input-decimal', (e) => {
      const charCode = e.which ? e.which : e.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && !(charCode == 46 || charCode == 8))
        e.preventDefault()
      else {
        const len = $(e.currentTarget).val().length
        const index = $(e.currentTarget).val().indexOf('.')
        if (index > 0 && charCode === 46) {
          e.preventDefault()
        }
        if (index > 0) {
          const CharAfterdot = (len + 1) - index;
          if (CharAfterdot > 3) {
            e.preventDefault()
          }
        }
      }
    })
  },
}

const newCalculator = (() => {
  if (internals.$this.length) {
    internals.init()
  }
})()
export default newCalculator